import styled from "styled-components";
import { useRef, useEffect } from "react";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import RoundActionIcon from "components/buttons/RoundActionIcon";

import crossIcon from "assets/img/icons/icons8-cross.svg";

const Preview = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  max-width: 1200px;
  padding: 0 10px;
  box-sizing: border-box;
  z-index: 2000;
`;

const PreviewModal = styled.div`
  position: relative;
  margin-top: 30px;
  width: 100%;
  padding: 25px 0px;
  box-sizing: border-box;
  height: calc(100vh - 120px);
  transform: translateY(-25px);

  overflow-y: auto;

  border-radius: ${css.BOX_RADIUS_PRIMARY};
  background: ${css.BLUE_BOX_GRADIENT};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  @media (min-width: ${globalConstants.switchMobile}) {
    margin-top: 0px;
  }
`;

const PreviewHeader = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${globalConstants.switchMobile}) {
    margin-top: 0px;
    padding: 0 25px;
  }
`;

const PreviewTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
`;

const CloseBox = styled.div`
  align-self: flex-start;
`;

const PreviewWrap = styled.div`
  width: 100%;
  padding: 0 25px;
  box-sizing: border-box;

  flex: 1;

  display: flex;

  @media (max-width: ${globalConstants.switchTablet}) {
    padding: 0 8px;
  }
`;

const PreviewBorderWrap = styled.div`
  border-radius: ${css.BOX_RADIUS_SECONDARY};
  overflow: hidden;

  display: flex;

  flex: 1;
`;

const PreviewIframe = styled.iframe`
  width: 100%;
  height: 100%;
`;

export default ({ subject, html, closePreview }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.contentDocument.open();
      iframe.contentDocument.write(html);
      iframe.contentDocument.close();
    }
  }, [html]);

  return (
    <Preview>
      <PreviewModal>
        <PreviewHeader>
          <PreviewTitle>{subject}</PreviewTitle>
          <CloseBox>
            <RoundActionIcon
              icon={crossIcon}
              iconAlt="Close"
              onClick={closePreview}
            />
          </CloseBox>
        </PreviewHeader>
        <PreviewWrap>
          <PreviewBorderWrap>
            <PreviewIframe
              ref={iframeRef}
              title="Message Preview"
            ></PreviewIframe>
          </PreviewBorderWrap>
        </PreviewWrap>
      </PreviewModal>
    </Preview>
  );
};
